module.exports = __webpack_public_path__ + "img/voce-sa.jpg";